import { UploadFailureReason } from "shared/attachments/types";

export const DEFAULT_CONTENT_TYPE = "application/octet-stream";

export const THUMBNAIL_MAX_SIDE = 480;

export const CREATE_THUMBNAIL_TIMEOUT_MS = 5000;

// fetch reports no upload progress, so a stalled PUT is only detectable as a
// deadline. Without one it holds its worker — and the import modal, which
// refuses to close while an upload is in flight — open forever. The allowance
// scales with the file so a slow link is not mistaken for a stall. The assumed
// rate is deliberately below any working uplink: overshooting only delays
// noticing a real stall, while undershooting aborts a transfer still in flight.
export const PUT_MIN_TIMEOUT_MS = 120_000;
export const PUT_ASSUMED_BYTES_PER_SECOND = 100 * 1024;

// Rejections and thumbnails the browser cannot draw come from the file itself, so
// they are reported as warnings; these are the failures on our side.
export const UPLOAD_FAULT_REASONS: UploadFailureReason[] = [
  "put_failed",
  "put_network_error",
  "put_timeout",
  "thumbnail_put_failed",
  "request_network_error",
  "request_timeout",
  "unexpected_error",
];
